<template>
  <div :class="['message-item', message.role, message.type]">
    <div v-if="isAi" class="message-profile">
      <i v-if="isLoading || isAnswering" class="icon icon--becle-entering"></i>
      <i v-else-if="message.error" class="icon icon--becle-crying"></i>
      <i v-else class="icon icon--becle-profile"></i>
    </div>
    <div v-else class="message-profile">{{ userData.userId[0] }}</div>
    <div class="message-text-container">
      <template v-if="!message.error">
        <span v-if="isLoading && isAi" class="loading-text">{{ $t('mine.chat.loading') }}</span>
        <div
          class="chat-message-text report-chat-md-content"
          v-html="disableParsing ? message.message : convertMarkdownToHtml(message.message)"
          linkTarget="_blank"
        ></div>
      </template>
      <p v-else class="bold" v-html="$t(`mine.chat.error.${message.error}`)" ></p>
      <i v-if="message.role === 'human'" class="icon icon--chat-arrow"></i>
    </div>
  </div>
</template>

<script>
import { convertMarkdownToHtml } from '@/libs/utils'

export default {
  name: 'MessageItem',
  props: {
    message: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isAnswering: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      default: () => ({})
    },
    disableParsing: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isAi () {
      return this.message.role === 'ai'
    }
  },
  methods: {
    convertMarkdownToHtml
  }
}
</script>

<style lang="scss" scoped>
.message-item {
  display: flex;
  width: 100%;
  max-width: 1317px;
  box-sizing: border-box;
  margin: 0 auto;

  .message-profile {
    flex-shrink: 0;
  }

  .message-text-container {
    position: relative;
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    .loading-text {
      &:after {
        padding-left: 2px;
        content: '';
        animation: dots 2.5s steps(3, end) infinite;
      }
      @keyframes dots {
        0%   { content: ''; }
        25%  { content: '.'; }
        50%  { content: '..'; }
        75%  { content: '...'; }
        100% { content: ''; }
      }
    }
    .chat-message-text {
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 10px;
      min-height: 24px;
      color: #262626;
      word-break: break-all;
      a,
      :-webkit-any-link {
        white-space: normal;
        word-break: break-all;
        text-decoration: underline;
      }
      ul {
        list-style: disc;
      }
    }
    .bold {
      font-weight: 600;
    }
  }

  &.human {
    align-items: flex-start;
    flex-direction: row-reverse;
    gap: 25px;
    padding: 4px 20px 12px;

    .message-profile {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      padding: 4px;
      background-color: #F7A300;
      box-sizing: border-box;
      border-radius: 5px;
      color: #FFF;
      font-size: 18px;
      font-weight: 600;
      text-transform: uppercase;
    }
    .message-text-container {
      padding: 12px;
      margin: 16px 0 0 12px;
      background-color: #FFF;
      border-radius: 16px;
      .icon--chat-arrow {
        position: absolute;
        top: -2px;
        right: -17px;
      }
    }
  }

  &.ai {
    padding: 12px 20px;
    gap: 12px;
    .message-profile {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: #BAC5FF;
      overflow: hidden;
    }
    .message-text-container {
      margin-top: 4px;
    }
  }
}
</style>
